import React, { Component } from 'react'
import { withStyles, Grid } from '@material-ui/core';
import { withSnackbar } from 'notistack';
import { FormControl } from '@material-ui/core';
// import { CircleToBlockLoading } from 'react-loadingg';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import 'date-fns';
import Button from '@material-ui/core/Button';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import * as XLSX from 'xlsx';
import * as moment from 'moment';
import Service from "../Networking/networkutils";
import Headers from '../ContractorPlanning/Headers';
import Switch from '@material-ui/core/Switch';
import { InputLabel, Select, MenuItem } from '@material-ui/core';

const useStyles = (theme) => ({
    button: {
        margin: theme.spacing(1),
    },
    dateField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        marginTop: theme.spacing(-1),
        padding: theme.spacing(0.25)
    },
});

class Report extends Component {
    _isMounted = false;
    constructor(props) {
        super(props);
        this.state = {
            reportType: this.props.type,
            selectedStartDate: new Date(),
            selectedFinishDate: new Date(),
            reinstatingCrews: [],
            ddCellsbyCrew: [],
            selectedCells: 0,
            workStatus: false,
        }
    }
    fetchCellsbyCrew() {
        Service.get('/bb/api/cellsby/')
            .then(res => {
                if (this._isMounted) {

                    var ddCells = [];
                    var cellData = res.data.map(s => s.cell).filter((v, i, a) => a.indexOf(v) === i).sort((a, b) => (a > b) ? 1 : -1);
                    for (let i = 0; i < cellData.length; i++) {
                        ddCells.push({ id: i, value: cellData[i] });
                    }
                    this.setState({ ddCellsbyCrew: ddCells });
                }
            })
            .catch(error => {
                this.props.enqueueSnackbar('Something went wrong!', { variant: 'error' });
            });
    }
    componentDidMount() {

        this._isMounted = true;
        this.fetchCellsbyCrew();
        Service.get('/bb/api/reinstating/crew').then(res => {
            var reinstatingCrewsObj = {};
            for (let i = 0; i < res.data.length; i++) {
                reinstatingCrewsObj[[res.data[i].id]] = res.data[i].name;
            }
            this.setState({ reinstatingCrews: reinstatingCrewsObj });
        }).catch(error => {
            this.props.enqueueSnackbar('Something went wrong while fetching Reinstating Crew !', { variant: 'error' });
        });
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {

        const downloadReport = () => {

            var start_dt = new moment(this.state.selectedStartDate, 'DD-MM-YYYY').format('DD-MM-YYYY');
            var finish_dt = new moment(this.state.selectedFinishDate, 'DD-MM-YYYY').format('DD-MM-YYYY');
            var workSheetName = "Report";
            var reportName = "Report.xlsx";
            var workBook = XLSX.utils.book_new();

            if (this.state.reportType === "Reinstating Crew Report") {

                workSheetName = "Reinstating Crew";
                reportName = "Reinstating_Crew_" + start_dt + "_to_" + finish_dt + ".xlsx";
                workBook = XLSX.utils.book_new();

                Service.get('/bb/api/surface/category/?date_created_start=' + start_dt + '&date_created_end=' + finish_dt)
                    .then(res => {
                        var workSheetdata = res.data.map(m => ([
                            m.Work_Order,
                            m.address,
                            Headers.lookupSurfaceCategory[m.surface_category],
                            Headers.lookupPrivatePublic[m.public_or_private],
                            m.length,
                            m.width,
                            this.state.reinstatingCrews[m.reinstating_crew],
                            (m.start_time) ? new moment(m.start_time).format('DD/MM/YYYY HH:mm:ss') : "",
                            (m.finish_time) ? new moment(m.finish_time).format('DD/MM/YYYY HH:mm:ss') : "",
                            m.reinstated_length,
                            m.reinstated_width,
                            m.reason_reinstatement,
                            Headers.lookupFullBay_FullRoadReinstatement[m.fullbay_fullroad]
                        ]));
                        workSheetdata.unshift(["Reinstating Crew"], ["Work Order No", "Address", "Surface Category", "Public / Private", "Opening Length", "Opening Width", "Reinstating Crew", "Start Time", "Finish Time", "Reinstated Length", "Reinstated Width", "Reason for Extra Over Reinstatement / Other Comments", "Full Bay / Full Road Reinstatement"])
                        var workSheet = XLSX.utils.aoa_to_sheet(workSheetdata);
                        XLSX.utils.book_append_sheet(workBook, workSheet, workSheetName);
                        XLSX.writeFile(workBook, reportName);
                    })
                    .catch(error => {
                        this.props.enqueueSnackbar('Something went wrong!', { variant: 'error' });
                    });

            }
            else if (this.state.reportType === "Pre-Construction Form Report") {
                workSheetName = "Pre-Construction Form";
                workBook = XLSX.utils.book_new();
                var workSheetdata = [];
                var isCompleted = this.state.workStatus ? "2" : "0,1";
                var cell = this.state.ddCellsbyCrew[this.state.selectedCells].value;
                var dt = new moment(new Date(), 'DD-MM-YYYY').format('DD/MM/YYYY');
                reportName = "Pre-Construction_Form_" + cell + "_" + (this.state.workStatus ? "Completed_" : "In-Progress_") + dt + ".xlsx";
                Service.get('/bb/api/precon/planning_api/?is_completed=' + isCompleted + '&Cell=' + cell).then(res => {
                    workSheetdata = res.data.map(m => ([
                        m.Work_Order,
                        m.Full_Address,
                        m.pre_con_form_data.Customer_Name,
                        m.pre_con_form_data.Role,
                        m.pre_con_form_data.Customer_phone_number,
                        m.pre_con_form_data.Customer_email,
                        m.pre_con_form_data.Special_conditions_or_remarks,
                        m.pre_con_form_data.Activity_description,
                        Headers.lookupJobPlan[m.Job_Plan],
                        (m.Appointment_Start) ? new moment(m.Appointment_Start).format('DD/MM/YYYY') : "",
                        m.pre_con_form_data.Meter_position,
                        m.pre_con_form_data.Road_class_or_type,
                        Headers.lookupFullBay_FullRoadReinstatement[m.pre_con_form_data.Is_site_visit_required],
                        (m.pre_con_form_data.Date_for_site_visit) ? new moment(m.pre_con_form_data.Date_for_site_visit).format('DD/MM/YYYY') : "",
                        m.pre_con_form_data.Estimated_job_duration,
                        m.pre_con_form_data.Type_of_licence_required,
                        m.pre_con_form_data.Type_of_TMP,
                        Headers.lookupFullBay_FullRoadReinstatement[m.pre_con_form_data.Any_public_buildings_vicinity],
                        Headers.lookupFullBay_FullRoadReinstatement[m.pre_con_form_data.Moratorium_in_place],
                        m.pre_con_form_data.Underground_ESB_present_on_map,
                        Headers.lookup_OverheadESBPresentOnMap[m.pre_con_form_data.Overhead_ESB_present_on_map],
                        Headers.lookupFullBay_FullRoadReinstatement[m.pre_con_form_data.Gas_transmission_lines_present_on_map],
                        m.pre_con_form_data.Location_of_main_on_gas_maps,
                        m.pre_con_form_data.Water_main_position,
                        m.pre_con_form_data.Sewer_position,
                        m.pre_con_form_data.Telecomm_services,
                        m.pre_con_form_data.Distance_in_private_ground,
                        m.pre_con_form_data.Gas_Main_to_building_line,
                        m.pre_con_form_data.Works_in_carriageway,
                        m.pre_con_form_data.Works_in_footpath,
                        m.pre_con_form_data.Works_in_verge,
                        m.pre_con_form_data.Special_surfaces,
                        m.pre_con_form_data.Line_painting,
                        m.pre_con_form_data.Traffic_lights_sensor_pads,
                        m.pre_con_form_data.Speed_limit,
                        m.pre_con_form_data.Road_width,
                        m.pre_con_form_data.Works_width,
                        m.pre_con_form_data.Side_Zone,
                        m.pre_con_form_data.Unobstructed_road_width,
                        Headers.lookup_RoadType[m.pre_con_form_data.Road_type],
                        Headers.lookupFullBay_FullRoadReinstatement[m.pre_con_form_data.Cycle_lanes_present],
                        m.pre_con_form_data.Parking_restrictions,
                        m.pre_con_form_data.three_minute_count_Time_of_day,
                        m.pre_con_form_data.Road_A,
                        m.pre_con_form_data.Road_B,
                        m.pre_con_form_data.Road_C,
                        m.pre_con_form_data.Road_D,
                        Headers.lookupFullBay_FullRoadReinstatement[m.pre_con_form_data.roads_with_higher_speed_limit_within_100m],
                        Headers.lookupFullBay_FullRoadReinstatement[m.pre_con_form_data.Pedestrian_crossings_vicinity],
                        Headers.lookupFullBay_FullRoadReinstatement[m.pre_con_form_data.Bus_stops_vicinity],
                        m.pre_con_form_data.main_location_confirmed_on_site,
                        m.pre_con_form_data.Is_SWI_required,
                        m.pre_con_form_data.Road_quality_or_demage,
                        m.pre_con_form_data.Any_TMP_restrictions,
                        m.pre_con_form_data.Stop_or_Go_board_required,
                        m.pre_con_form_data.Adequate_access_or_room_works,
                        m.pre_con_form_data.Type_of_machine_required,
                        m.pre_con_form_data.Overhead_lines,
                        m.pre_con_form_data.Customer_contacted_or_present,
                        m.pre_con_form_data.meter_location_agreed,
                        m.pre_con_form_data.Indication_of_underground_structures,
                        m.pre_con_form_data.Any_third_party_works_vicinity,
                        m.pre_con_form_data.Any_public_buildings_not_identified_on_maps,
                        m.pre_con_form_data.Walls_fences_boundaires_affected,
                        m.pre_con_form_data.Restricted_access,
                        m.pre_con_form_data.Photos_taken,
                        (m.pre_con_form_data.Application_date) ? new moment(m.pre_con_form_data.Application_date).format('DD/MM/YYYY') : "",
                        (m.pre_con_form_data.Licence_received_date) ? new moment(m.pre_con_form_data.Licence_received_date).format('DD/MM/YYYY') : "",
                        (m.pre_con_form_data.Valid_from) ? new moment(m.pre_con_form_data.Valid_from).format('DD/MM/YYYY') : "",
                        m.pre_con_form_data.Licence_reference_no,
                        m.pre_con_form_data.Special_licence_conditions,
                        (m.pre_con_form_data.Valid_to) ? new moment(m.pre_con_form_data.Valid_to).format('DD/MM/YYYY') : "",
                        Headers.lookupRestrictedHours[m.pre_con_form_data.Restricted_hours],
                        Headers.lookupFullBay_FullRoadReinstatement[m.pre_con_form_data.Is_SWI_required_for_licence_conditions],
                        m.pre_con_form_data.Was_TMP_designed,
                        m.pre_con_form_data.License_Type,
                        m.pre_con_form_data.LA_Contact_Name,
                        m.pre_con_form_data.LA_contact_phone_number
                    ]));
                    workSheetdata.unshift(["WO number", "Address", "Customer name", "Role (Owner, Builder, etc.)", "Customer phone number", "Customer email", "Special conditions / remarks", "Activity description", "Job code", "Appointment / target start date", "Meter position", "Road class / type", "Is site visit required ?", "Date for site visit", "Estimated job duration (hrs)", "Type of licence required ?", "Type of TMP (Generic/Site specific)", "Any public buildings in vicinity?", "Moratorium in place?", "Underground ESB present on map (LV/MV/HV)", "Overhead ESB present on map (LV/MV/HV)", "Gas transmission lines present on map", "Location of main on gas maps", "Water main position", "Sewer position", "Telecomm. services", "Distance in private ground", "Gas Main to building line", "Works in carriageway (Identify surface i.e. HRA, SMA)", "Works in footpath (Identify surface i.e. 10mm, Concrete, slabs)", "Works in verge", "Special surfaces(i.e. granite)", "Line painting", "Traffic lights sensor pads", "Speed limit (km/h)", "Road width (m)", "Works width(m)", "Side Zone (m)", "Unobstructed road width (m)", "Road type (Single / Dual/one way or two way)", "Cycle lanes present?", "Parking bays affected? Parking restrictions", "3 minute count Time of day?", "Road A", "Road B", "Road C", "Road D", "Any roads with higher speed limit within 100m?", "Pedestrian crossings in vicinity", "Bus stops in vicinity", "Main location confirmed on site?", "Is SWI required?", "Road quality, any pre existing damages? (take photos)", "Any TMP restrictions", "Stop / Go board required?", "Adequate access / room for works", "Type of machine required", "Overhead lines (type, approximate height)", "Was Customer contacted / present?", "Was meter location agreed?", "Indication of underground structures?", "Any third party works in vicinity", "Any public buildings not identified on maps", "Walls / fences / boundaries affected?", "Restricted access", "Photos taken?", "Application date", "Licence received date", "Valid from", "Licence reference no", "Special licence conditions?", "Valid to", "Restricted hours?", "Is SWI required for licence conditions?", "Was TMP designed (date / generic)", "Licence type", "LA Contact Name", "LA contact phone number"]);
                    var workSheet = XLSX.utils.aoa_to_sheet(workSheetdata);
                    XLSX.utils.book_append_sheet(workBook, workSheet, workSheetName);
                    XLSX.writeFile(workBook, reportName);
                }).catch(error => {
                    this.props.enqueueSnackbar('Something went wrong!', { variant: 'error' });
                });
            }
        }

        const handleStartDateChange = (dt) => {
            this.setState({ selectedStartDate: dt });
        }

        const handleFinishDateChange = (dt) => {
            this.setState({ selectedFinishDate: dt });
        }
        const statusChanged = (event) => {
            var value = event.target.checked;
            this.setState({ workStatus: value });
        }
        const loadGridData = (ev, ele) => {
            this.setState({ selectedCells: parseInt(ev.target.value) });
        };
        return (
            <div>
                <Grid container spacing={3}>
                    <h2>{this.state.reportType}</h2>
                    {
                        (this.state.reportType === "Reinstating Crew Report") ?
                            <Grid container alignItems="center" >
                                <Grid item xs={2}>
                                    <FormControl size="small" variant="outlined" className={useStyles.textField} fullWidth>
                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <KeyboardDatePicker value={this.state.selectedStartDate} onChange={handleStartDateChange} className={useStyles.dateField} style={{ width: "100%" }} name="selectedStartDate" label="Start Date" format="dd/MM/yyyy" KeyboardButtonProps={{ 'aria-label': 'Change date', }} />
                                        </MuiPickersUtilsProvider>
                                    </FormControl>
                                </Grid>
                            &nbsp;&nbsp;&nbsp;
                            <Grid item xs={2}>
                                    <FormControl size="small" variant="outlined" className={useStyles.textField} fullWidth>
                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <KeyboardDatePicker value={this.state.selectedFinishDate} onChange={handleFinishDateChange} className={useStyles.dateField} style={{ width: "100%" }} name="selectedFinishDate" label="Finish Date" format="dd/MM/yyyy" KeyboardButtonProps={{ 'aria-label': 'Change date', }} minDate={this.state.selectedStartDate} />
                                        </MuiPickersUtilsProvider>
                                    </FormControl>
                                </Grid>
                            &nbsp;&nbsp;&nbsp;
                            <Grid item>
                                    <Button onClick={downloadReport} variant="contained" color="primary" className={useStyles.button} startIcon={<CloudDownloadIcon />}>Download</Button>
                                </Grid>
                            </Grid>
                            : (this.state.reportType === "Pre-Construction Form Report") ?
                                <Grid container alignItems="center" >
                                    <Grid item xs={3}>
                                        <FormControl size="small" variant="outlined" className={useStyles.textField} fullWidth>
                                            <InputLabel id="label">Cell</InputLabel>
                                            <Select labelId="label" name="selectedCells" value={this.state.selectedCells} onChange={loadGridData} label="Cell">
                                                {this.state.ddCellsbyCrew.map((cell) => (
                                                    <MenuItem key={cell.value} value={cell.id}>
                                                        {cell.value}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item >&nbsp;&nbsp;&nbsp;In Progress <p>   </p></Grid>
                                    <Grid item >
                                        <Switch value={this.state.workStatus} onChange={statusChanged} name="workStatus" />
                                        <p>   </p>
                                    </Grid>
                                    <Grid item>Completed <p>   </p></Grid>
                                    <Grid item >&nbsp;&nbsp;&nbsp; <p>   </p></Grid>

                            &nbsp;&nbsp;&nbsp;

                            &nbsp;&nbsp;&nbsp;
                            <Grid item>
                                        <Button onClick={downloadReport} variant="contained" color="primary" className={useStyles.button} startIcon={<CloudDownloadIcon />}>Download</Button>
                                    </Grid>
                                </Grid>

                                :
                                null
                    }
                </Grid>
            </div >
        )
    }
}
export default withStyles(useStyles)(withSnackbar(Report));